import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBohbuKe4Y7bzUgCJWyNkL4gA5OMG1vmdc",
  authDomain: "providers-5ab5f.firebaseapp.com",
  projectId: "providers-5ab5f",
  storageBucket: "providers-5ab5f.appspot.com",
  messagingSenderId: "975477992009",
  appId: "1:975477992009:web:5b692d0b7279540d39ad98",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();
const storage = getStorage();

export { app, auth, db, storage };
